import { ENV } from '@/lib/config/env';

export const CREATIVE_FLOWS_APP_ID = 'creative-flows';

/**
 * Derives the Creative Flows host from PLATFORM_BASE_URL so dev, staging and
 * prod each resolve to their own subdomain.
 * e.g. https://dev.monksflow.ai -> https://creative-flows.dev.monksflow.ai/?workspaceId={workspaceId}
 */
const getCreativeFlowsUrl = (workspaceId: string): string => {
  const { hostname, protocol } = new URL(ENV.PLATFORM_BASE_URL);
  const params = new URLSearchParams({ workspaceId });
  return `${protocol}//creative-flows.${hostname}/?${params.toString()}`;
};

/**
 * Opens Creative Flows in the same tab, so the transition feels like a regular
 * in-app navigation and browser back returns to the previous Monks.Flow page.
 */
export const openCreativeFlowsTool = (workspaceId: string): void => {
  window.open(getCreativeFlowsUrl(workspaceId), '_self');
};
